// src/components/tour/tours/userManager.jsx
//
// Client User Manager tour (/user-manager - client admins only).
// ctx is registered in ClientAdminManager.jsx.

import React from 'react';
import { replayStep } from './common';

const RoleChip = ({ role, children }) => <span className={`cm-role-chip cm-${role}`}>{children}</span>;

export function getUserManagerSteps(ctx, env) {
    const { company, deviceCount = 0, expandCompany } = ctx;
    const { isMobile } = env;
    const users = company?.users || [];

    return [
        {
            target: null,
            title: 'Manage your team',
            content: (
                <p>
                    As an admin for <span className="pt-data">{company?.client_name || 'your company'}</span>, you decide
                    who on your team can log in and what they can do.{' '}
                    {users.length > 0 && <>There are <span className="pt-data">{users.length}</span> users right now.</>}
                </p>
            ),
        },
        {
            target: '[data-tour="um-company"]',
            title: 'Your company',
            content: (
                <p>
                    Your account status and how many devices (<span className="pt-data">{deviceCount}</span>) and
                    users you have. The devices are the ones on the sites your provider linked to you.
                </p>
            ),
        },
        {
            target: '[data-tour="um-actions"]',
            title: 'Add a user',
            content: (
                <p>
                    <b>+ USER</b> creates a login. They receive an email to verify their address and set a password.
                    <b> {isMobile ? 'Expand' : 'EXPAND'}</b> shows your devices and users.
                </p>
            ),
        },
        {
            target: '[data-tour="um-detail"]',
            onEnter: expandCompany,
            title: 'Roles & actions',
            content: (
                <>
                    <p>
                        <RoleChip role="admin">ADMIN</RoleChip> everything, including this page and changing WAN
                        priority / important items;{' '}
                        <RoleChip role="operator">OPERATOR</RoleChip> dashboards plus the Alert Dashboard;{' '}
                        <RoleChip role="viewer">VIEWER</RoleChip> view-only.
                    </p>
                    <p>
                        <b>RESET PW</b> emails a reset link, <b>NOTIF ON/OFF</b> controls push notifications on their
                        phone (viewers don't get any), and <b>DEACTIVATE</b> blocks sign-in without deleting.
                        You can't edit, deactivate or delete your own account here.
                    </p>
                </>
            ),
        },
        replayStep,
    ];
}
